export default __webpack_public_path__ + "static/media/monocle.da080efe.png";